module.exports = __webpack_public_path__ + "img/55.7.Chla.6023929b.png";